import React from 'react';
import PropTypes from 'prop-types';
import CombinedImage from '../CombinedImage/CombinedImage';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('ImageWithChild');

const ImageWithChild = (props) => {
    const { children, className, src, ...rest } = props;
    const { wrapper = className, image } = className || {};

    return (
        <div className={bem(null, null, wrapper)}>
            {src && <CombinedImage src={src} className={image} {...rest} />}
            {children && <div className={bem('child')}>{children}</div>}
        </div>
    );
};

ImageWithChild.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    src: PropTypes.string,
};

export default ImageWithChild;
